import { CDN_URL, LOGOS_PATH } from "@utils/cdn"

export function HeaderBrandingSeaq() {
	return (
		<div className={`-mr-2.5 flex min-w-80 flex-row justify-end gap-3`}>
			<p className={`text-body min-w-25 pt-3.5 font-medium text-white`}>Powered by</p>
			<img
				src={`${CDN_URL}/${LOGOS_PATH}/seaq_white.svg`}
				alt={"SeaQ logo"}
				className="mt-4.5 h-5 w-24.5"
			/>
			<img
				src={`${CDN_URL}/${LOGOS_PATH}/vard.svg`}
				alt={"Vard logo"}
				className="mt-4.5 h-5 w-23.5"
			/>
		</div>
	)
}
